import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

import { MatTabGroup } from '@angular/material/tabs';
import { MatPaginator } from '@angular/material/paginator';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { BehaviorSubject, Subject, merge } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { ReportDetailsService } from '../../report.details.service';

import { schemaGroup } from '../../report.group';
import { ReportColumn, ReportSchema } from '../../report';

@Component({
   selector: 'lib-report-fields',
   templateUrl: './fields.component.html',
   styleUrls: ['./fields.component.scss'],
   outputs: [ 'valid' ],
})
export class FieldsComponent implements OnInit, OnDestroy {

   fields: FormArray = this.report.reportForm.get( 'schema' ) as FormArray;

   get valid() { return this.fields.length && this.fields.valid; }

   available$: BehaviorSubject<ReportColumn[]> = new BehaviorSubject( [] );

   columns: Map<string, ReportColumn> = new Map();
   filter: FormControl = new FormControl();

   _onDestroy: Subject<void> = new Subject();

   @ViewChild( MatPaginator ) paginator!: MatPaginator;
   page = 0;
   pageSize = 10;
   get start() { return this.page * this.pageSize; }
   get end() { return this.start + this.pageSize; }

   @ViewChild( MatTabGroup ) tabs!: MatTabGroup;

   constructor(
      public report: ReportDetailsService,
   ) { }

   ngOnInit(): void {
      merge(
         this.fields.valueChanges,
         this.filter.valueChanges,
      ).pipe(
         map( _ => {
            const names = this.fields.value.map( f => f.name );

            return [ ...this.columns.keys() ].filter( key => names.indexOf( key ) === -1 )
               .map( key => this.columns.get( key ));
         }),
         map( fields => {
            if ( !this.filter.value ) { return fields; }
            const value = this.filter.value.trim().toLowerCase();

            return fields.filter( f => f?.header.toLowerCase().includes( value ));

         }),
         takeUntil( this._onDestroy ),
      ).subscribe( fields => this.available$.next( fields ));

      this.report.columns.pipe(
         map( columns => columns.filter( c => c.columns )),
         map( columns => columns.sort(( a, b ) => ( a?.sort_order ?? 0 ) - ( b?.sort_order ?? 0 ))),
         takeUntil( this._onDestroy ),
      ).subscribe( columns => {
         columns.map( c => this.columns.set( c.name, c ));
         this.fields.updateValueAndValidity();
      });
   }

   ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
   }

   add( schema: ReportSchema ) {
      this.fields.push( schemaGroup( schema ));
   }

   drop( event: CdkDragDrop<string[]> ) {
      const fields = this.fields.value;
      moveItemInArray( fields, event.previousIndex, event.currentIndex );
      this.fields.setValue( fields );
   }

   hasPrimarySort(): boolean {
      return !!this.fields.value.map( f => f.sort_ord )
         .filter( sort_ord => !!sort_ord ).length;
   }
}
